import { motion } from 'framer-motion'
import React from 'react'
import Services from '../Organisms/Services'


export const pageVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition:{delay:.5,duration:.5,}
  },
  exit: {
    x:'-100vw',
    transition:{ease:'easeInOut',duration:.5}
  },
}
const Home = () =>{

  return(
    <motion.main initial="initial"
    animate="animate"
    exit='exit'
    variants={pageVariants}
     >
      <Services />
    </motion.main>
  )
}
export default Home